import Vue from 'vue'
import Cookies from 'js-cookie'
import DefaultLanguage from '@/core/js/DefaultLanguage'
import Settings from '@/config/Settings'

const route = {
  name: null,
  meta: { 
    lang: DefaultLanguage, 
    name: null
  }
}

export default {
  namespaced: true,
  state: {
    lang: DefaultLanguage,
    mode: Settings.mode,
    route: {
      from: route,
      to: route
    },
    touch_screen: false,
    motion_left: 0,
    motion_right: 0,
    weave_button: 'show',
    status: 'init',
    add_listen: false,
    scale: 0, 
    rotation: 0, 
    recenter: 0,
    line: 0,
    audio: 'none'
  },
  mutations: {
    'SET_MODE' (state, mode) {
      state.mode = mode
    },
    'RESET_MODE' (state) {
      state.mode = Settings.mode
    },
    'SET_FROM_ROUTE' (state, from) {
      state.route.from = from
    },
    'SET_TO_ROUTE' (state, to) {
      state.route.to = to
    },
    'LANG_REFRESH' (state) {
      const l = state.lang
      state.lang = 'none'
      state.lang = l
    },
    'LANG_CHANGED' (state, lang) {
      state.lang = lang
      Cookies.set(Settings.cookies.lang, state.lang)
    },
    'MOTION_LEFT' (state) {
      state.motion_left += 1
    },
    'MOTION_RIGHT' (state) {
      state.motion_right += 1
    },
    'TOUCH_SCREEN' (state, bool) {
      // console.log(bool);
      state.touch_screen = bool
    },
    'WEAVE_BUTTON' (state, mode) {
      state.weave_button = mode
    },
    'UPDATE_STATUS' (state, status) {
      // console.log('UPDATE_STATUS : '+ status);
      state.status = status
    },
    'ADD_LISTEN' (state, status) {
      state.add_listen = status
    },
    'UPDATE_SCALE' (state, scale) {
      state.scale = scale
    },
    'UPDATE_ROTATION' (state, rotation) {
      state.rotation = rotation
    },
    'RECENTER' (state) {
      state.recenter += 1
    },
    'UPDATE_LINE' (state, val) {
      state.line = val
    },
    'SYNC_AUDIO' (state, audio) {
      state.audio = audio
    },
  },
  getters: {
    lang: state => state.lang,
    mode: state => state.mode,
    route: state => state.route,
    motion_left: state => state.motion_left,
    motion_right: state => state.motion_right,
    touch_screen: state => state.touch_screen,
    weave_button: state => state.weave_button,
    status: state => state.status,
    add_listen: state => state.add_listen,
    scale: state => state.scale,
    rotation: state => state.rotation,
    recenter: state => state.recenter,
    line: state => state.line,
    audio: state => state.audio, 
  }
}